export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //スクロール量を取得する関数
    function getScrolled() {
      return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
    }

    //トップに戻るボタンの要素を取得
    var topButton = document.getElementById( 'js-scroll-fadein' );

    //ボタンの表示・非表示
    window.onscroll = function() {
      ( getScrolled() > 500 ) ? topButton.classList.add( 'is-fadein' ): topButton.classList.remove( 'is-fadein' );
    }

    //スマホでアンカーリンクズレ対策
    // window.onload = function () {
    //   if(window.location.hash==""){return;}
    //   document.getElementById(window.location.hash.slice(1)).scrollIntoView(true);
    // }

    //トップに移動する関数
    // function scrollToTop() {
    //   var scrolled = getScrolled();
    //   window.scrollTo( 0, Math.floor( scrolled / 2 ) );
    //   if ( scrolled > 0 ) {
    //     window.setTimeout( scrollToTop, 30 );
    //   }
    // }

    //イベント登録
    // topButton.onclick = function() {
    //   scrollToTop();
    // }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js